window.BaseAPI = function () {
    var self = this;
    var _protected = {};

    var cachedModels = {};

    var uniqueRequests = {};

    var endpointsExecludedToken = [
        'https://www.googleapis.com/language/translate/v2/detect',
        'https://www.googleapis.com/language/translate/v2'
    ];

    self.apiUrl = publicConfiguration.APIServerBaseURL;

    _protected.CACHING_TIMEOUT = 60 * 1000; // Default caching is 1 minute

    _protected.setApiUrl = function (apiUrl) {
      self.apiUrl = apiUrl;
    };

    _protected.uniqueRequest = function (endpoint, method, params, withoutCredentials, timeout) {
        return _protected.request(endpoint, method, params, withoutCredentials, timeout, true);
    };
    var request = function(endpoint, method, params, extraHeaders, withoutCredentials, timeout, avoidDuplicate) {
      var defer = $q.defer();
      var url = self.apiUrl + endpoint;
        var paramsStringified = JSON.stringify(params);

        if (endpoint.indexOf("://") > -1) {
            url = endpoint;
        }

        var httpConfig = {
            url: url,
            method: method,
            withCredentials: !withoutCredentials
        };

        var uniqueIdentifier = [method, url].join(":");
        uniqueRequests[uniqueIdentifier] = uniqueRequests[uniqueIdentifier] || { params: {} };

        if (method === 'GET' || method === 'DELETE') {
            httpConfig.params = params;
        }
        else {
            httpConfig.data = params;
        }

        // Add CSRF header to all non GET requests headers
        httpConfig.headers = extraHeaders || {};

        if (typeof window !== "undefined" && url.includes('gateway.harri')) {
            httpConfig.headers["X-REFERRER-PAGE"] = window.location.href.substring(0, 255);
        }

        if (['GET', 'HEAD', 'OPTIONS', 'TRACE'].indexOf(method) < 0) {
            var csrfToken = HStorageManager.get({
                key: "csrftoken",
                storageLevel: HStorageManager.StorageLevels.COOKIES,
                codec: false
            });
            csrfToken = csrfToken && decodeURI(csrfToken);
            httpConfig.headers["X-CSRFTOKEN"] = csrfToken;
            // This is a workaround to overcome the problem of the logged out users on the old frontend code who didn't refresh their broswer,
            // please come here later on and remove this shit
            // My manager Feras Kayali has approved this shit. If you want to contact him here is his phone number:
            // 0595316248
            httpConfig.headers["FORCE-CSRF"] = true;
        }

        if (timeout) {
            httpConfig.timeout = timeout;
        }

        if (uniqueRequests[uniqueIdentifier].params[paramsStringified]) {
            if (['GET', 'DELETE'].indexOf(method) > -1 || avoidDuplicate) {
                console.warn("Prevented duplicate HTTP:", method, url);
                return uniqueRequests[uniqueIdentifier].params[paramsStringified];
            }
            else {
                console.error("Duplicate HTTP:", method, url, "Params:", params);
            }
        }

        uniqueRequests[uniqueIdentifier].params[paramsStringified] = defer.promise;
        hLoginManager.getToken().then(function(token){

            if(token && _protected.isTokenNeeded(url)) {
                httpConfig.headers['Authorization'] = 'Bearer ' + token;
            }

            var promise = $http(httpConfig);

            promise.then(function (resp) {
                defer.resolve(resp);
                delete uniqueRequests[uniqueIdentifier].params[paramsStringified];
            }, function (e) {
                defer.reject(e);
                delete uniqueRequests[uniqueIdentifier].params[paramsStringified];
            });

        });

        return defer.promise;
    };

    _protected.requestWithHeaders = function(endpoint, method, params, extraHeaders) {
        return request(endpoint, method, params, extraHeaders);
    };

    _protected.request = function(endpoint, method, params, withoutCredentials, timeout, avoidDuplicate) {
        return request(endpoint, method, params, null, withoutCredentials, timeout, avoidDuplicate)
    };

    _protected.clearCache = function (cacheKey) {
        if (cacheKey) {
            delete cachedModels[cacheKey];
        }
        else {
            cachedModels = {};
        }

    };

    _protected.isTokenNeeded = function (url) {
        return endpointsExecludedToken.indexOf(url) === -1;
    };

    _protected.getCached = function (cacheKey) {
        if (cacheKey && cachedModels[cacheKey] && (Date.now() - cachedModels[cacheKey].time) <= _protected.CACHING_TIMEOUT) {
            return cachedModels[cacheKey].data;
        }

        return null;
    }

    _protected.cache = function (cacheKey, data) {
        cachedModels[cacheKey] = {
            data: data,
            time: Date.now()
        };
    }

    _protected.handleResponse = function (data, deferred) {
        if (data.status_code == 200) {
            deferred.resolve(data.data);
        }
        else {
            deferred.reject(data);
        }
    };


    return _protected;
}
